import type SVGType from 'types/svg.types';

const WalletIcon: SVGType = (props) => (
  <svg
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M25.6663 11V23C25.6663 24.4728 24.4724 25.6667 22.9997 25.6667H8.99967C7.52692 25.6667 6.33301 24.4728 6.33301 23V9"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M22.0003 17.3333C22.0003 17.7015 21.7018 18 21.3337 18C20.9655 18 20.667 17.7015 20.667 17.3333C20.667 16.9651 20.9655 16.6666 21.3337 16.6666C21.7018 16.6666 22.0003 16.9651 22.0003 17.3333Z"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M22.9997 11H8.66634C7.37768 11 6.33301 9.95537 6.33301 8.66671C6.33301 7.37804 7.37768 6.33337 8.66634 6.33337H20.333C21.8058 6.33337 22.9997 7.52728 22.9997 9.00004V11ZM22.9997 11H25.6663"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default WalletIcon;
